import type { ContentfulPageViewModel } from 'autogen/swagger/all';
import { ContentfulLivePreview } from '@contentful/live-preview';
import { ContentfulLivePreviewProvider } from '@contentful/live-preview/react';
import type { ReactNode } from 'react';

export default function Preview({
    model,
    children
}: { model: ContentfulPageViewModel['useCaseModel']; children: ReactNode }) {
    const { contentfulLocale } = model;

    if (!ContentfulLivePreview.initialized) {
        ContentfulLivePreview.init({
            locale: contentfulLocale
        });
    }
    return <ContentfulLivePreviewProvider locale={contentfulLocale}>{children}</ContentfulLivePreviewProvider>;
}
